import {SubmissionLog, UserDto, UserRole} from '../../scaffold';

export function getVisibleSubmissionLogs(logs: SubmissionLog[] | null | undefined, currentUser?: UserDto): SubmissionLog[] {
  const allLogs = logs || [];
  if (currentUser?.role === UserRole.管理员) return allLogs;

  const logOperationMark = currentUser?.name ? `操作人：${currentUser.name}` : '';
  if (!logOperationMark) return [];

  return allLogs.filter(log => !!log.remark?.includes(logOperationMark));
}
